import { render, staticRenderFns } from "./DealActivityModal.vue?vue&type=template&id=842a2644&scoped=true&"
import script from "./DealActivityModal.vue?vue&type=script&lang=js&"
export * from "./DealActivityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842a2644",
  null
  
)

export default component.exports